import { makeStyles } from '@material-ui/core/styles'
import { Box, Button, Divider, Grid, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import LoadingModal from 'src/components/common/LoadingModal'
import { getAge, scrollToTop } from 'src/utils/commonMethods'
import { getTokenForQrReport } from 'src/services/individualService'
import { CONTACT, NOTIFICATION_TYPES } from 'src/utils/constants/common'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import MotorPriceDetails from 'src/components/BuyPolicy/insuranceScreens/motor/MotorPriceDetails'
import BackArrow from 'src/assets/Buy_Policy_Images/arrow.svg'
import {
  getMotorFullQuoteDetails,
  getMotorFullQuoteRequestBody,
  getPremiumBreakup,
  getProposalDetailsMotor,
  getUserDetailsObject,
} from 'src/services/buyPolicyMotorService'
import userIconBlue from 'src/assets/Buy_Policy_Images/userIconBlue.svg'
import infoToolTip from 'src/assets/Buy_Policy_Images/infoToolTip.svg'
import {
  showNotificationMessage,
  updateCurrentPolicyDetailsMotor,
  updateMotorNomineeDetails,
  updatePACoverArray,
  updatePaymentLink,
  updatePersonalDetailsMotor,
  updatePreviousPolicyDetailsMotor,
  updateSelectedQuoteMotor,
  updateVehicleDetailsMotor,
} from 'src/actions'
import { formatDateMonth } from 'src/utils/commonMethods/formatDate'
import { POLICY_TYPE_MOTOR } from 'src/utils/constants/BuyPolicyMotor'
import {
  ERROR_ENCOUNTERED_ON_QOUTE,
  ERROR_OCCURED_ON_PROPOSAL,
  ERROR_ON_PAYMNET_INITITATION,
  premiumBreakUp_Provider_List,
  QUOTE_404,
  RELATION_TYPES,
} from 'src/utils/constants/BuyPolicy'
import ContactUs from 'src/components/BuyPolicy/insuranceScreens/health/ContactUs'
import {
  paymentRedirection,
  setPaymentInitiation,
} from 'src/services/buyPolicyService'
import motorFourWheeler from 'src/assets/Buy_Policy_Images/motorFourWheeler.svg'
import { VEHICLE_TYPE } from 'src/utils/constants/BuyPolicyBike'
import { getBikeFullQuote } from 'src/services/buyPolicyBikeService'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'

const TermsAndConditionMotor = () => {
  const classes = useStyles()
  const history = useHistory()
  const { search } = useLocation()
  const dispatch = useDispatch()
  const guestUserDetails = useSelector((state) => state?.buyPolicyMotorReducer)
  const personalDetails = guestUserDetails?.personalDetails
  const vehicleDetails = guestUserDetails?.vehicleDetails
  const nomineeDetails = guestUserDetails?.nomineeDetails
  const selectedQuote = guestUserDetails?.selectedQuote
  const currentPolicyDetails = guestUserDetails?.currentPolicyDetails
  const previousPolicyDetails = guestUserDetails?.previousPolicyDetails
  const [loading, setLoading] = useState(false)
  const [loadingFullQuote, setLoadingFullQuote] = useState(false)
  const [token, setToken] = useState(null)
  const [isFullQuoteFetchError, setIsFullQuoteFetchError] = useState(false)
  const [checkboxData, setCheckboxData] = useState({
    agreeToTerms: false,
    notCommercial: false,
  })

  const isPremiumBreak = false
  const [fullQuote, setFullQuote] = useState()
  const [paCover, setPACover] = useState(currentPolicyDetails?.paCover)
  const searchParams = React.useMemo(
    () => new URLSearchParams(search),
    [search]
  )
  const enquiryId = searchParams.get('enquiryId')

  useEffect(() => {
    scrollToTop()
    fetchToken()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paCover])

  const fetchToken = async () => {
    setLoading(true)
    const response = await getTokenForQrReport()
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      setLoading(false)
      const token = response?.res?.data?.access_token
      setToken(token)
      if (enquiryId) {
        fetchProposerDetails(token, enquiryId)
      } else {
        vehicleDetails.vehicleType === VEHICLE_TYPE?.TWO_WHEELER
          ? fetchBikeFullQuoteDetails(token)
          : fetchMotorFullQuoteDetails(token)
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
        })
      )
    }
  }

  const fetchProposerDetails = async (token, enquiryId) => {
    const response = await getProposalDetailsMotor(token, enquiryId)

    try {
      if (response?.res?.status !== 200) {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      const responseData = response?.res?.data

      if (responseData) {
        const {
          vehicleDetails,
          personalDetails,
          currentPolicyDetails,
          selectedQuote,
          previousPolicyDetails,
          nomineeDetails,
        } = getUserDetailsObject({ ...responseData })

        dispatch(updateVehicleDetailsMotor(vehicleDetails))
        dispatch(updatePersonalDetailsMotor(personalDetails))
        dispatch(updatePreviousPolicyDetailsMotor(previousPolicyDetails))
        dispatch(updateCurrentPolicyDetailsMotor(nomineeDetails))
        dispatch(updateSelectedQuoteMotor(selectedQuote))
        dispatch(updateCurrentPolicyDetailsMotor(currentPolicyDetails))
        dispatch(updateMotorNomineeDetails(nomineeDetails))
        dispatch(updatePACoverArray(responseData?.fieldValues?.paDetails))

        const formBody = responseData?.fullQuoteRequest
        responseData?.fieldValues?.vehicleType === VEHICLE_TYPE?.TWO_WHEELER
          ? fetchBikeFullQuoteDetails(token, formBody)
          : fetchMotorFullQuoteDetails(token, formBody)
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: ERROR_OCCURED_ON_PROPOSAL,
          })
        )
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message: ERROR_OCCURED_ON_PROPOSAL,
        })
      )
    }
  }

  const fetchMotorFullQuoteDetails = async (token, formBody) => {
    setLoadingFullQuote(true)
    const requestBody =
      formBody ?? getMotorFullQuoteRequestBody(guestUserDetails)
    const response = await getMotorFullQuoteDetails(token, requestBody)
    try {
      if (response?.res?.status !== 200) {
        setLoadingFullQuote(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoadingFullQuote(false)
      const responseData = response?.res?.data
      if (responseData?.success) {
        if (premiumBreakUp_Provider_List?.includes(selectedQuote?.providerId)) {
          fetchPremiumBreakUpDetails(
            token,
            responseData?.fullQuoteRequest?.enquiryId
          )
        }
        setFullQuote(responseData?.quoteDetails?.[0])
        dispatch(updateSelectedQuoteMotor(responseData?.quoteDetails?.[0]))
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      setLoadingFullQuote(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message: ERROR_ENCOUNTERED_ON_QOUTE,
        })
      )
      setIsFullQuoteFetchError(true)
    }
  }
  const fetchBikeFullQuoteDetails = async (token, formBody) => {
    setLoadingFullQuote(true)

    const requestBody =
      formBody ?? getMotorFullQuoteRequestBody(guestUserDetails)

    const response = await getBikeFullQuote(token, requestBody)

    try {
      if (response?.res?.status !== 200) {
        setLoadingFullQuote(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoadingFullQuote(false)
      const responseData = response?.res?.data
      if (responseData?.success) {
        setFullQuote(responseData?.quoteDetails?.[0])
        dispatch(updateSelectedQuoteMotor(responseData?.quoteDetails?.[0]))
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      setLoadingFullQuote(false)
      setIsFullQuoteFetchError(true)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message: ERROR_ENCOUNTERED_ON_QOUTE,
        })
      )
    }
  }

  const handleBack = () => {
    history.goBack()
  }

  const handleChange = (event) => {
    setCheckboxData({
      ...checkboxData,
      [event.target.name]: event?.target?.checked,
    })
  }

  const handlePay = async () => {
    if (!fullQuote) {
      setIsFullQuoteFetchError(true)
    } else {
      setLoading(true)
      try {
        const policyId = fullQuote?.policyNumber

        if (policyId) {
          const paymentInitiationResponse = await setPaymentInitiation(
            token,
            policyId
          )

          try {
            if (paymentInitiationResponse?.res?.status !== 200) {
              setLoading(false)
              dispatch(
                showNotificationMessage({
                  type: NOTIFICATION_TYPES.ERROR,
                  message:
                    NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
                })
              )
            }
            // Success
            setLoading(false)
            const responseData = paymentInitiationResponse?.res?.data
            if (responseData?.success) {
              navigateToPaymentPage()
            } else {
              dispatch(
                showNotificationMessage({
                  type: NOTIFICATION_TYPES.ERROR,
                  message: responseData?.message,
                })
              )
            }
          } catch (err) {
            setLoading(false)
            dispatch(
              showNotificationMessage({
                type: NOTIFICATION_TYPES.ERROR,
                message: ERROR_ON_PAYMNET_INITITATION,
              })
            )
          }
        } else {
          navigateToPaymentPage()
        }
      } catch (err) {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: QUOTE_404,
          })
        )
      }
    }
  }

  const fetchPremiumBreakUpDetails = async (token, enquiry_Id) => {
    setLoading(true)

    const response = await getPremiumBreakup(token, enquiry_Id)
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success

      const responseData = response?.res?.data
      dispatch(
        updateSelectedQuoteMotor({
          ...selectedQuote,
          premiumBreak: responseData?.groups,
          ownDamagePremium: responseData?.ownDamagePremium || '',
          thirdPartyPremium: responseData?.thirdPartyPremium || '',
        })
      )
      setLoading(false)
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message:
            NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_POLICY_DETAILS,
        })
      )
    }
  }

  const navigateToPaymentPage = () => {
    setLoading(true)
    const updatedFullQuote = fullQuote
    let paymentLink = updatedFullQuote?.paymentLink
    if (updatedFullQuote?.paymentRequestParameterName) {
      paymentLink = `${updatedFullQuote?.paymentLink}?${updatedFullQuote?.paymentRequestParameterName}=${updatedFullQuote?.paymentRequestParameterValue}`
    }
    dispatch(updatePaymentLink(paymentLink))
    paymentRedirection(updatedFullQuote, paymentLink, history)
  }

  return (
    <>
      <LoadingModal loading={loading || loadingFullQuote} />
      <Box className={classes.componentBackground}>
        <Box className={classes.componentElement}>
          <Box className={classes.containerMain}>
            <Grid container spacing={3} direction='column'>
              <Grid item container direction='row' spacing={4}>
                <Grid item xs={12} md={8.2}>
                  <Box className={classes.userDetailsContainer}>
                    <Box>
                      {isFullQuoteFetchError ? null : (
                        <Box className={classes.reviewMessageContainer}>
                          <Box
                            className={classes.conatinerBack}
                            onClick={handleBack}
                          >
                            <img
                              src={BackArrow}
                              alt='back-arrow-img'
                              className={classes.backArrowImage}
                            />
                            <Box className={classes.conatinerBackText}>
                              Summary
                            </Box>
                          </Box>

                          <Box>
                            <Box className={classes.reviewText}>
                              Please review the following information.
                            </Box>
                            <Box className={classes.policyDocumentText}>
                              These details will be printed on your policy
                              document.
                            </Box>
                          </Box>
                        </Box>
                      )}
                    </Box>

                    <Box>
                      <div className={classes.mainContainer}>
                        {isFullQuoteFetchError ? (
                          <div className={classes.errorMessageContainer}>
                            <div className={classes.errorContainer}>
                              <div className={classes.errorTextContainer}>
                                <span className={classes.errorText}>
                                  Oops, seems something went wrong. Please go
                                  back, verify and submit the details again.
                                </span>
                              </div>
                              <div className={classes.errorTextContainer}>
                                <span className={classes.errorText}>Or</span>
                              </div>
                              <div>
                                <span className={classes.errorText}>
                                  Please call us at <b>{CONTACT.Contact}</b> for
                                  further assistance.
                                </span>
                              </div>
                            </div>
                            <div className={classes.errorBackContainer}>
                              <Button
                                type={'button'}
                                onClick={handleBack}
                                className={classes.backButton}
                                id='backButton'
                              >
                                Back
                              </Button>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <div className={classes.summaryContainer}>
                              <div className={classes.vehicalSummary}>
                                <div className={classes.imageSection}>
                                  <img
                                    src={
                                      vehicleDetails?.vehicleLogo
                                        ? vehicleDetails?.vehicleLogo
                                        : motorFourWheeler
                                    }
                                    alt='vehicle-logo-img'
                                    className={classes.summaryImages}
                                  />
                                </div>{' '}
                                <div className={classes.detailsSection}>
                                  <Grid
                                    container
                                    spacing={3}
                                    className={classes.summaryRow}
                                  >
                                    <Grid item className={classes.rowItem}>
                                      <Grid
                                        item
                                        className={classes.headingText}
                                      >
                                        {vehicleDetails?.brand?.genericName}
                                      </Grid>
                                      <Grid item className={classes.valueText}>
                                        {`${
                                          vehicleDetails?.model
                                            ?.modelGenericName || ''
                                        } ${
                                          vehicleDetails?.variant
                                            ?.genericVariantName || ''
                                        }`}
                                      </Grid>
                                    </Grid>
                                    <Grid item className={classes.rowItem}>
                                      <Grid
                                        item
                                        className={classes.headingText}
                                      >
                                        Reg. Number:
                                      </Grid>
                                      <Grid item className={classes.valueText}>
                                        {vehicleDetails?.vehicleNumber}
                                      </Grid>
                                    </Grid>
                                    <Grid item className={classes.rowItem}>
                                      <Grid
                                        item
                                        className={classes.headingText}
                                      >
                                        Reg Year
                                      </Grid>
                                      <Grid item className={classes.valueText}>
                                        {formatDateMonth(
                                          vehicleDetails?.regDate ?? '-'
                                        )}
                                      </Grid>
                                    </Grid>
                                    <Grid item className={classes.rowItem}>
                                      <Grid
                                        item
                                        className={classes.headingText}
                                      >
                                        Fuel Type
                                      </Grid>
                                      <Grid item className={classes.valueText}>
                                        {vehicleDetails?.fuelType?.genericName}
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid
                                    container
                                    spacing={3}
                                    className={classes.summaryRow}
                                  >
                                    <Grid item className={classes.rowItem}>
                                      <Grid
                                        item
                                        className={classes.headingText}
                                      >
                                        IDV:
                                      </Grid>
                                      <Grid item className={classes.valueText}>
                                        {formatToINR(selectedQuote?.idvCover) ??
                                          '-'}
                                      </Grid>
                                    </Grid>
                                    <Grid item className={classes.rowItem}>
                                      <Grid
                                        item
                                        className={classes.headingText}
                                      >
                                        Coverage Type
                                      </Grid>
                                      <Grid item className={classes.valueText}>
                                        {
                                          POLICY_TYPE_MOTOR[
                                            currentPolicyDetails?.policyType
                                          ]
                                        }
                                      </Grid>
                                    </Grid>
                                    <Grid item className={classes.rowItem}>
                                      <Grid
                                        item
                                        className={classes.headingText}
                                      >
                                        Eligible NCB%{' '}
                                        <Tooltip
                                          arrow
                                          title={
                                            <>
                                              <Box>
                                                Based on your declaration,
                                                you&apos;ve said you didn&apos;t
                                                make any claims in your last
                                                policy and had a $50% NCB.
                                              </Box>
                                            </>
                                          }
                                        >
                                          <img
                                            src={infoToolTip}
                                            alt={infoToolTip}
                                            className={classes.infoImage}
                                          />
                                        </Tooltip>
                                      </Grid>
                                      <Grid item className={classes.valueText}>
                                        {previousPolicyDetails?.ncb ?? '0'}%
                                      </Grid>
                                    </Grid>
                                    {vehicleDetails?.externalCngLpgKitAmount ? (
                                      <Grid item className={classes.rowItem}>
                                        <Grid
                                          item
                                          className={classes.headingText}
                                        >
                                          External CNG Kit Amount
                                        </Grid>
                                        <Grid
                                          item
                                          className={classes.valueText}
                                        >
                                          {formatToINR(
                                            vehicleDetails?.externalCngLpgKitAmount
                                          )}
                                        </Grid>
                                      </Grid>
                                    ) : null}
                                    {vehicleDetails?.loanProviderName ? (
                                      <Grid item className={classes.rowItem}>
                                        <Grid
                                          item
                                          className={classes.headingText}
                                        >
                                          Hypothecated To
                                        </Grid>
                                        <Grid
                                          item
                                          className={classes.valueText}
                                        >
                                          <span className={classes.capitalize}>
                                            {vehicleDetails?.loanProviderName?.loanProviderName
                                              ?.toString()
                                              ?.toLowerCase()}
                                          </span>
                                        </Grid>
                                      </Grid>
                                    ) : null}
                                  </Grid>
                                  <Grid
                                    container
                                    spacing={3}
                                    className={classes.summaryRow}
                                  >
                                    <Grid item className={classes.rowItem}>
                                      <Grid
                                        item
                                        className={classes.headingText}
                                      >
                                        New policy start date
                                      </Grid>
                                      <Grid item className={classes.valueText}>
                                        {formatDateMonth(
                                          selectedQuote?.policyStartDate
                                        )}
                                      </Grid>
                                    </Grid>
                                    <Grid item className={classes.rowItem}>
                                      <Grid
                                        item
                                        className={classes.headingText}
                                      >
                                        New policy end date
                                      </Grid>
                                      <Grid item className={classes.valueText}>
                                        {formatDateMonth(
                                          selectedQuote?.policyEndDate
                                        )}
                                      </Grid>
                                    </Grid>
                                    <Grid item className={classes.rowItem}>
                                      <Grid
                                        item
                                        className={classes.headingText}
                                      >
                                        Engine Number
                                      </Grid>
                                      <Grid item className={classes.valueText}>
                                        {vehicleDetails?.engineNumber}
                                      </Grid>
                                    </Grid>
                                    <Grid item className={classes.rowItem}>
                                      <Grid
                                        item
                                        className={classes.headingText}
                                      >
                                        Chassis Number
                                      </Grid>
                                      <Grid item className={classes.valueText}>
                                        {vehicleDetails?.chassisNumber}
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid
                                    container
                                    spacing={3}
                                    className={classes.summaryRow}
                                  >
                                    <Grid item className={classes.rowItem}>
                                      <Grid
                                        item
                                        className={classes.headingText}
                                      >
                                        Previous Policy Number
                                      </Grid>
                                      <Grid item className={classes.valueText}>
                                        {
                                          previousPolicyDetails?.previousPolicyNumber
                                        }
                                      </Grid>
                                    </Grid>
                                    <Grid item className={classes.rowItem}>
                                      <Grid
                                        item
                                        className={classes.headingText}
                                      >
                                        Previous Policy Expiry Date
                                      </Grid>
                                      <Grid item className={classes.valueText}>
                                        {formatDateMonth(
                                          previousPolicyDetails?.expiryDate
                                        )}
                                      </Grid>
                                    </Grid>
                                    <Grid item className={classes.rowItem}>
                                      <Grid
                                        item
                                        className={classes.headingText}
                                      >
                                        Previous Policy Insurer
                                      </Grid>
                                      <Grid item className={classes.valueText}>
                                        {
                                          previousPolicyDetails
                                            ?.previousPolicyProvider
                                            ?.insuranceCompanyName
                                        }
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </div>
                              </div>
                              <Divider
                                variant='middle'
                                className={classes.divider}
                              />
                              <div className={classes.personalSummary}>
                                <div className={classes.imageSection}>
                                  <img
                                    src={userIconBlue}
                                    alt='back-arrow-img'
                                    className={classes.summaryImages}
                                  />
                                </div>
                                <div className={classes.detailsSection}>
                                  <Grid
                                    container
                                    spacing={3}
                                    className={classes.summaryRow}
                                  >
                                    {vehicleDetails?.companyName ? (
                                      <Grid item className={classes.rowItem}>
                                        <Grid
                                          item
                                          className={classes.headingText}
                                        >
                                          Company Name
                                        </Grid>
                                        <Grid
                                          item
                                          className={classes.valueText}
                                        >
                                          {vehicleDetails?.companyName}
                                        </Grid>
                                      </Grid>
                                    ) : null}
                                    {vehicleDetails?.companyPAN ? (
                                      <Grid item className={classes.rowItem}>
                                        <Grid
                                          item
                                          className={classes.headingText}
                                        >
                                          Company PAN
                                        </Grid>
                                        <Grid
                                          item
                                          className={classes.valueText}
                                        >
                                          {vehicleDetails?.companyPAN}
                                        </Grid>
                                      </Grid>
                                    ) : null}
                                    {vehicleDetails?.companyGSTIN ? (
                                      <Grid item className={classes.rowItem}>
                                        <Grid
                                          item
                                          className={classes.headingText}
                                        >
                                          Company GSTIN
                                        </Grid>
                                        <Grid
                                          item
                                          className={classes.valueText}
                                        >
                                          {vehicleDetails?.companyGSTIN}
                                        </Grid>
                                      </Grid>
                                    ) : null}
                                  </Grid>
                                  <Grid
                                    container
                                    spacing={3}
                                    className={classes.summaryRow}
                                  >
                                    <Grid item className={classes.rowItem}>
                                      <Grid
                                        item
                                        className={classes.headingText}
                                      >
                                        Owner Name
                                      </Grid>
                                      <Grid item className={classes.valueText}>
                                        {personalDetails?.firstName +
                                          ' ' +
                                          personalDetails?.lastName}
                                      </Grid>
                                    </Grid>
                                    <Grid item className={classes.rowItem}>
                                      <Grid
                                        item
                                        className={classes.headingText}
                                      >
                                        Mobile
                                      </Grid>
                                      <Grid item className={classes.valueText}>
                                        {personalDetails?.mobileNumber ?? '-'}
                                      </Grid>
                                    </Grid>
                                    <Grid item className={classes.rowItem}>
                                      <Grid
                                        item
                                        className={classes.headingText}
                                      >
                                        Email
                                      </Grid>
                                      <Grid item className={classes.valueText}>
                                        {personalDetails?.email ?? '-'}
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid
                                    container
                                    spacing={3}
                                    className={classes.summaryRow}
                                  >
                                    <Grid item className={classes.rowItem}>
                                      <Grid
                                        item
                                        className={classes.headingText}
                                      >
                                        Address
                                      </Grid>
                                      <Grid item className={classes.valueText}>
                                        {personalDetails?.fullAddress +
                                          ', ' +
                                          personalDetails?.city +
                                          ', ' +
                                          personalDetails?.state +
                                          ', ' +
                                          personalDetails?.pincode}
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid
                                    container
                                    spacing={3}
                                    className={classes.summaryRow}
                                  >
                                    <Grid item className={classes.rowItem}>
                                      <Grid
                                        item
                                        className={classes.headingText}
                                      >
                                        Nominee Details
                                      </Grid>
                                      <Grid item className={classes.valueText}>
                                        {`${nomineeDetails?.nomineeFirstName} ${
                                          nomineeDetails?.nomineeLastName
                                        } - ${getAge(
                                          nomineeDetails?.nomineeDOB
                                        )} (${
                                          RELATION_TYPES[
                                            nomineeDetails?.nomineeRelationType
                                          ]
                                        })`}
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </div>
                              </div>
                            </div>
                            <div className={classes.checkBoxSection}>
                              <div className={classes.conditions}>
                                <div>
                                  <input
                                    id='notCommercial'
                                    name='notCommercial'
                                    value={checkboxData.notCommercial}
                                    type='checkbox'
                                    onChange={handleChange}
                                    className={classes.checkboxControl}
                                    checked={true}
                                  />
                                </div>
                                <div className={classes.conditionsCheck}>
                                  <span
                                    className={classes.conditionsContentCheck}
                                  >
                                    I consent to the terms and conditions.
                                  </span>
                                </div>
                              </div>
                              {/* <div className={classes.conditions}>
                                <div>
                                  <input
                                    id='grantAuthorization'
                                    name='grantAuthorization'
                                    //value={checkboxData.grantAuthorization}
                                    type='checkbox'
                                    onChange={handleChange}
                                    className={classes.checkboxControl}
                                  />
                                </div>
                                <div className={classes.conditionsCheck}>
                                  <span className={classes.conditionsContentCheck}>
                                    I confirm that my prior policy is a $comprehensive policy with a
                                    $50% No Claim Bonus (NCB), and there $havebeenno claims.
                                  </span>
                                </div>
                              </div> */}
                              <div className={classes.conditions}>
                                <div>
                                  <input
                                    id='notCommercial'
                                    name='notCommercial'
                                    value={checkboxData.notCommercial}
                                    type='checkbox'
                                    onChange={handleChange}
                                    className={classes.checkboxControl}
                                    checked={true}
                                  />
                                </div>
                                <div className={classes.conditionsCheck}>
                                  <span
                                    className={classes.conditionsContentCheck}
                                  >
                                    My vehicle is not used for commercial
                                    purposes, and it holds a valid PUC(Pollution
                                    Under Control) certificate.
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} md={3.8}>
                  <MotorPriceDetails
                    // fullQuote={fullQuote}
                    handlePay={handlePay}
                    paCover={paCover}
                    setPACover={setPACover}
                    enquiryId={selectedQuote.enquiryId}
                    isPremiumBreakUp={isPremiumBreak}
                  />
                  <Box className={classes.contactSection}>
                    <ContactUs color='linear-gradient(142.32deg, #4DC3E3 -476.58%, #FFFFFF 81.03%)' />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default TermsAndConditionMotor

const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    width: '100%',
    marginRight: '40px',
  },
  conditionsCheck: {
    marginLeft: '10px',
  },
  conditionsContentCheck: {
    fontFamily: 'Roboto',
    fontSize: '16px',
  },
  detailsContainer: {
    display: 'flex',
    marginBottom: '20px',
    gap: '10px',
  },
  nameDetails: {
    color: '#47BBDB',
    fontSize: '16px',
    fontFamily: 'Roboto',
  },
  otherDetails: {
    color: '#000000',
    fontSize: '13px',
    fontFamily: 'Roboto',
  },
  otherSubDetails: {
    color: '#959595',
    fontSize: '11px',
    fontFamily: 'Roboto',
  },
  errorMessageContainer: {
    padding: '40px',
  },
  errorContainer: {
    textAlign: 'center',
    background: 'linear-gradient( #EF669B -760%, #FFFFFF 100%)',
    border: 'none',
    padding: '50px 80px 50px 80px',
    boxShadow: '0px 6px 8px 0px #4DC3E333',
    borderRadius: '10px',
  },
  errorTextContainer: {
    paddingBottom: '10px',
  },
  errorText: {
    fontSize: '18px',
    textAlign: 'center',
  },
  errorBackContainer: {
    textAlign: 'center',
    padding: '10%',
  },
  disabledButton: {
    opacity: '0.5',
  },
  checkboxControl: {
    cursor: 'pointer',
    height: '15px',
    width: '15px',
  },
  conditionsContentDescription: {
    fontFamily: 'Roboto',
    fontSize: '16px',
  },
  conditions: {
    marginBottom: '15px',
    display: 'flex',
    alignItems: 'center',
  },
  containerMain: {
    padding: '10px 10px 60px 10px',
    background: 'linear-gradient(180deg, #DFF7FF 4.08%, #FFFFFF 102.47%)',
    backgroundSize: '100% 40%',
    backgroundRepeat: 'no-repeat',
    backgroundColor: '#FFFFFF',
  },
  userDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    paddingTop: 10,
  },
  conatinerBack: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    cursor: 'pointer',
  },
  conatinerBackText: {
    fontFamily: 'Roboto',
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '0.9375em',
    letterSpacing: '0em',
    color: '#3E3E3E',
  },
  userDetailsContainerText: {
    fontFamily: 'Roboto',
    fontSize: '1.125em',
    fontWeight: 500,
    lineHeight: '1.6875em',
    letterSpacing: '0em',
    color: '#000000',
  },
  userDetailsContainerTextSecondary: {
    fontFamily: 'Roboto',
    fontSize: '0.8125em',
    fontWeight: 400,
    lineHeight: '1.25em',
    letterSpacing: '0em',
    color: '#7C7C7C',
  },
  componentElement: {
    maxWidth: '1240px !important',
    width: '100%',
    padding: '10px 0px 10px 0px',
  },
  componentBackground: {
    background: 'linear-gradient(180deg, #DFF7FF 4.08%, #FFFFFF 102.47%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: '100% 40%',
    backgroundRepeat: 'no-repeat',
    backgroundColor: '#FFFFFF',
  },
  reviewMessageContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  backArrowImage: { width: '17px', height: '12px' },
  reviewText: {
    fontFamily: 'Roboto',
    fontSize: '19px',
    fontWeight: 600,
    lineHeight: '24.78px',
    textAlign: 'right',
  },
  policyDocumentText: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '24.78px',
    textAlign: 'right',
  },
  headingText: {
    fontFamily: 'Roboto',
    fontWeight: '500',
    lineHeight: '18.75px',
    paddingLeft: '0%',
    fontSize: '12px',
    wordBreak: 'break-word',
    maxWidth: '150px',
    color: '#878787',
  },
  valueText: {
    fontWeight: '600',
    lineHeight: '18.75px',
    padding: '2px',
    fontSize: '14px',
  },
  summaryContainer: {
    background: '#FFFFFF',
    boxShadow: '0px 0px 10px 0px #00000033',
    padding: '20px 40px',
    border: '1px',
    borderRadius: '10px',
  },
  vehicalSummary: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    paddingBottom: '20px',
  },
  personalSummary: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    paddingTop: '20px',
  },
  summaryImages: {
    height: '40px',
    width: '40px',
  },
  imageSection: { height: '60px', width: '60px' },
  detailsSection: {},
  divider: { margin: '0px 0px' },
  summaryRow: { padding: '10px 0px' },
  rowItem: { minWidth: '160px' },
  checkBoxSection: {
    paddingTop: '30px',
  },
  contactSection: {
    paddingTop: '20px',
  },
  capitalize: {
    textTransform: 'capitalize',
  },
  backButton: {
    color: '#2BA6C8 !important',
    fontFamily: 'Roboto !important',
    fontSize: '16px !important',
    cursor: 'pointer !important',
    width: '120px',
    border: '1px !important',
    padding: '10px !important',
    borderRadius: '10px !important',
    background: '#E4EFF2 !important',
    textTransform: 'none !important',
    fontWeight: '600 !important',
  },
})
